import Swal, { SweetAlertIcon } from "sweetalert2";
import { fireThemedAlert } from "../../../utility/sweetAlert/theme";

export const alert = (message, action: SweetAlertIcon, codeHttp?) => {
  fireThemedAlert({
    title: codeHttp ? `Error ${codeHttp ?? ""}` : undefined,
    text: message,
    icon: action,
    timer: action == "success" ? 3000 : undefined,
    showClass: {
      popup: "animate__animated animate__fadeIn",
    },
  });
};

export const alertRedirect = (message, action: SweetAlertIcon, url) => {
  Swal.fire({
    text: message,
    icon: action,
    timer: 6000,
    timerProgressBar: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    showCloseButton: false,
    showCancelButton: false,
  }).then((result) => {
    if (result.dismiss === Swal.DismissReason.timer) {
      location.href = url;
    }
  });
};

export const alertLoading = (message, action: SweetAlertIcon) => {
  Swal.fire({
    title: message,
    icon: action,
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    showConfirmButton: false,
    showCloseButton: false,
    showCancelButton: false,
    didOpen: () => {
      Swal.showLoading(null);
    },
  });
};

export const alertBackPage = (message, action: SweetAlertIcon) => {
  fireThemedAlert({
    text: message,
    icon: action,
    showCancelButton: false,
    confirmButtonText: "Voltar",
  }).then((result) => {
    if (result.isConfirmed) {
      window.history.back();
    }
  });
};

export { mergeSwalTheme, fireThemedAlert, MySwal } from "../../../utility/sweetAlert/theme";
